import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  useId,
} from '@fluentui/react-components';
import { CheckmarkRegular, ClipboardPasteRegular } from '@fluentui/react-icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button/Button';
import { Input } from '../Input';
import './FileShareLinkDialog.scss';

export interface FileShareLinkDialogProps {
  link: string;
  onCloseClick: () => void;
}

/**
 * Dialog displays a share link for a drive file.
 */
export const FileShareLinkDialog: React.FC<FileShareLinkDialogProps> = ({ link, onCloseClick }) => {
  const { t } = useTranslation();
  const headerId = useId('fileShareLinkDialogHeader');
  const linkInputLabelId = useId('fileSharelinkDialogLinkInputLabel');
  const [isLinkCopied, setIsLinkCopied] = useState<boolean>(false);

  const handleBtnCopyToClipboardClick = () => {
    navigator.clipboard.writeText(link);
    setIsLinkCopied(true);
  };

  return (
    <Dialog open={true}>
      <DialogSurface aria-labelledby={headerId}>
        <DialogBody>
          <DialogTitle id={headerId}>
            {t('filesharelink_dialog_header', { defaultValue: 'Datei freigeben' })}
          </DialogTitle>
          <DialogContent>
            <div className="FileShareLinkDialog flex flex-col gap-2">
              <span id={linkInputLabelId}>
                {t('filesharelink_dialog_link_input_label', {
                  defaultValue:
                    'Geben Sie den untenstehenden Link an die gewünschten Empfänger weiter, um die gewählte Datei freizugeben',
                })}
              </span>
              <div className="flex gap-2">
                <Input
                  aria-describedby={linkInputLabelId}
                  value={link}
                  readOnly
                  className="flex-1"
                />
                <Button
                  aria-label={t('filesharelink_dialog_copy_link_label', {
                    defaultValue: 'Der untenstehende Link wird in die Zwischenablage kopiert',
                  })}
                  icon={
                    isLinkCopied ? <CheckmarkRegular className="linkCopiedIcon" /> : <ClipboardPasteRegular />
                  }
                  onClick={handleBtnCopyToClipboardClick}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onCloseClick}>
              {t('close', { defaultValue: 'Schließen' })}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
